import { useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { hasPrivilege } from "../api/token";
import RouterCard from "../components/RouterCard";

function RouterEdit() {
  const navigate = useNavigate();
  const params = useParams();
  const manufacture_edit = hasPrivilege('manufacture_edit');

  useEffect(() => {
    if (!manufacture_edit) {
      navigate("/");
    }
  }, [navigate, manufacture_edit])

  if (manufacture_edit) {
    return <RouterCard ident={params.id} editable={true} />;
  }
}

export default RouterEdit;
